<template>
  <van-overlay :show="visible">
    <div class="backgroundimage-bg"></div>
    <div class="popup">
      <div class="popup-main">
        <van-icon
          class="close-icon"
          name="close"
          color="white"
          size="30"
          @click="clickClose" />
        <div class="popup-main-body">
          <div class="top"></div>
          <div class="content-bg">
            <div class="left">
              <div class="value">{{ params.amount }}</div>
              <div class="unit">{{ params.unit }}</div>
            </div>
            <div class="right">
              <div class="c1">{{ params.content }}</div>
              <div class="c2">{{ params.content1 }}</div>
            </div>
          </div>
          <div class="use-bg">
            <div
              :class="params.isInterest ? 'use-btn1' : 'use-btn'"
              @click="onImmediateClaim"></div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
    
    <script>
import { Overlay, Icon } from "vant"

export default {
  name: "SuccessPop",
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  },
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {}
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("update:visible", false)
    },
    onImmediateClaim() {
      this.clickClose()
      this.$emit("commitUse")
    }
  }
}
</script>
    
    <style lang="less" scoped>
.van-overlay {
  z-index: 99;
}
.backgroundimage-bg {
  display: flex;
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
}
.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);

  .popup-main {
    overflow: hidden;
    .close-icon {
      position: absolute;
      top: -25px;
      right: 20px;
    }
    .popup-main-body {
      height: 100vw;
      width: 100vw;
      background: url(../../../assets/img/pop/ratecoupon_bg.jpg) no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      .top {
        flex: 2;
      }
      .content-bg {
        flex: 1;
        display: flex;
        margin-left: 20%;
        width: 60%;
        color: white;
        margin-bottom: 6px;
        .left {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 900;
          font-size: 15px;
          width: 75px;
          margin-left: 15px;
          background: linear-gradient(to right, white, rgb(255, 233, 179));
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          .value {
            font-size: 25px;
          }
          .unit {
            margin-bottom: -10px;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          margin-left: -6px;
          width: calc(100% - 95px);
        }
      }
      .use-bg {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;
        .use-btn {
          background: url(../../../assets/img/pop/ratecoupon_btn.jpg) no-repeat;
        }
        .use-btn1 {
          background: url(../../../assets/img/pop/ratecoupon_use_btn.jpg)
            no-repeat;
        }
        .use-btn,
        .use-btn1 {
          background-size: 100% 100%;
          width: 146px;
          height: 39px;
        }
      }
    }
  }
}
</style>
    